<template>
  <div class="home-index">
    <home-card></home-card>
    <search-input></search-input>
    <book-carousel></book-carousel>
  </div>
</template>

<script>
import TheHeading from '@/components/TheHeading.vue'
import DataCard from '../../components/DataCard.vue'
import BookCarousel from '../../components/BookCarousel.vue'
import TheFooter from '../../components/TheFooter.vue'
import SearchInput from '../../components/SearchInput.vue'
import HomeCard from '../../components/HomeCard.vue'
export default {
  name: 'HomeIndex',
  components: {
    TheHeading,
    DataCard,
    BookCarousel,
    TheFooter,
    SearchInput,
    HomeCard
  }
}
</script>

<style scoped>
.home-index {
  width: 100%;
  height: 100%;
  padding-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue